module.exports = __webpack_public_path__ + "static/media/stofferingen-43.e1a6bb7a.jpg";